import defaultColor from "@/components/color";
export default {
    cptDataForm: {
        dataText: '{"value":"114.427144,30.494745"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute:{
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        label:'一键导航',
        bgColor:defaultColor[0], 
        textColor:'#ffffff',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        borderSize:1,
        borderColor:defaultColor[0],
        borderRadius:5,
        lineType:'solid',
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
    },
    interaction:{ intType: 'none'}
}